import React, { memo } from "react";

import { Block, ContentType, ImageBlock, TableBlock, TextBlock } from "../../types";
import { InnodomImage as Image } from "./InnodomImage";
import { Table } from "./Table";
import { Text } from "./Text";
import { Props } from "./types";

const InnodomContentComponent = <B extends Block>({ block, ...remaining }: Props<B>) => {
  switch (block.type) {
    case ContentType.Image:
    case ContentType.Math:
      return <Image {...remaining} block={block as ImageBlock} onAddCorrections={undefined} />;
    case ContentType.Table: {
      const previewImage = <Image {...remaining} block={block as ImageBlock} />;
      return <Table {...remaining} block={block as TableBlock} previewImage={previewImage} />;
    }
    case ContentType.Text: {
      const previewImage = <Image {...remaining} block={block as ImageBlock} />;
      return <Text {...remaining} block={block as TextBlock} previewImage={previewImage} />;
    }
    case ContentType.TableCell:
      return null;
  }
};
InnodomContentComponent.displayName = "InnodomContent";
export const InnodomContent = memo(InnodomContentComponent);
